(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Colour filter row: one tap shows only that colour's cards. */
  (() => {
    const init = (bar) => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const grid = bar.closest('ul');
      if (!grid) return;
      const chips = [...bar.querySelectorAll('[data-colour-value]')];
      const status = bar.querySelector('[data-colour-status]');
      const param = bar.dataset.param || 'colour';

      const apply = (value, updateUrl) => {
        let shown = 0;
        grid.querySelectorAll(':scope > li').forEach((li) => {
          if (li.contains(bar)) return;
          const key = li.dataset.colourKey;
          const match = !value || key === value;
          li.hidden = !match;
          if (match) shown++;
        });
        chips.forEach((chip) => {
          const on = chip.dataset.colourValue === value;
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (status) {
          const active = chips.find((c) => c.dataset.colourValue === value);
          status.textContent = value && active ? `Showing ${shown} in ${active.dataset.colourLabel}` : `Showing all ${shown}`;
        }
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (value) url.searchParams.set(param, value);
          else url.searchParams.delete(param);
          history.replaceState(history.state, '', url.toString());
        }
      };

      chips.forEach((chip) =>
        chip.addEventListener('click', () => {
          apply(chip.dataset.colourValue, true);
          // If the shopper has scrolled into the grid, bring them back to the top of the results
          const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--cf-sticky-top'), 10) || 0;
          const gridTop = grid.getBoundingClientRect().top;
          if (gridTop < offset) {
            window.scrollTo({ top: window.scrollY + gridTop - offset, behavior: 'smooth' });
          }
        })
      );

      const initial = new URL(window.location.href).searchParams.get(param) || '';
      const valid = chips.some((c) => c.dataset.colourValue === initial);
      if (initial && valid) apply(initial, false);
    };

    // Keep the sticky filter row just under the header. Flora's header hides when scrolling
    // down and slides back in when scrolling up, so this follows it rather than being fixed.
    let stickyHeader;
    const findStickyHeader = () => {
      const header = document.querySelector('header-component, #header-component, .header');
      for (let el = header; el && el !== document.body; el = el.parentElement) {
        const pos = getComputedStyle(el).position;
        if (pos === 'sticky' || pos === 'fixed') return el;
      }
      return null;
    };
    const setStickyTop = () => {
      if (stickyHeader === undefined) stickyHeader = findStickyHeader();
      const top = stickyHeader ? Math.max(0, Math.round(stickyHeader.getBoundingClientRect().bottom)) : 0;
      document.documentElement.style.setProperty('--cf-sticky-top', `${top}px`);
    };
    let ticking = false;
    const queueStickyTop = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        setStickyTop();
      });
    };

    const run = () => {
      const bars = document.querySelectorAll('[data-colour-filter]');
      if (!bars.length) return;
      bars.forEach(init);
      setStickyTop();
      if (!window.__colourFilterBound) {
        window.__colourFilterBound = true;
        window.addEventListener('scroll', queueStickyTop, { passive: true });
        window.addEventListener('resize', queueStickyTop, { passive: true });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
